import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IJobOffer } from '../../../../../assets/types/dtoTypes';
import { environment } from '../../../../environments/environment';

@Injectable( {
  providedIn: 'root',
} )
export class JobService {
  private http = inject(HttpClient);

  private readonly jobUrl = `${environment.apiUrl}/job-offers`;

  languages: { name: string; code: string }[] = [];

  constructor() {}

  createJobOffer( jobData: Partial<IJobOffer> ): Observable<IJobOffer> {
    return this.http.post<IJobOffer>( this.jobUrl, jobData );
  }

  getJobOffer( jobId: string ): Observable<IJobOffer> {
    return this.http.get<IJobOffer>( `${this.jobUrl}/${jobId}` );
  }

}
